import styled, { css } from 'styled-components';
import { Input } from '@chegg-ui/input';
import { colors, spacing, font } from '@chegg-ui/theme';
import { Button, SecondaryButton } from '@chegg-ui/button';
import { Link as CUILink } from '@chegg-ui/link';
export var EmailInput = styled(Input).withConfig({
  componentId: "sc-1mpvovc-0"
})(["input{-webkit-appearance:none;}> label{color:", ";}div[role='alert']{margin-block-end:", ";}"], colors.dark, spacing.px16);
export var Centered = styled.div.withConfig({
  componentId: "sc-1mpvovc-1"
})(["display:grid;place-items:center;text-align:center;gap:", ";"], spacing.px24);
var footerFontSize = css(["font-size:", ";line-height:", ";"], font.size.px12, font.lineHeight.md);
export var FlipViewButton = styled(SecondaryButton).withConfig({
  componentId: "sc-1mpvovc-2"
})(["border:0;padding:0;", ";"], footerFontSize);
export var InputErrorButton = styled(SecondaryButton).withConfig({
  componentId: "sc-1mpvovc-3"
})(["font-size:", ";line-height:", ";margin-block-start:0.0625rem;border:0;padding-inline-start:", ";&.mergedError{font-size:0.8rem;padding:0 ", ";@supports (-moz-appearance:none){font-size:", ";}}&[data-test='existing_email_flip_reset_password_button']{@supports (-moz-appearance:none){padding:0;}}"], font.size.px14, font.lineHeight.md, spacing.px4, spacing.px4, font.size.px14);
export var Footer = styled.footer.withConfig({
  componentId: "sc-1mpvovc-4"
})(["", ";text-align:center;p{margin-block:", ";}"], footerFontSize, spacing.px16);
export var SubmitButton = styled(Button).withConfig({
  componentId: "sc-1mpvovc-5"
})(["display:flex;justify-content:center;align-items:center;margin:0 auto;margin-top:", ";&:disabled{color:white;background:", ";border-color:", ";opacity:0.5;}"], spacing.px24, colors.cheggOrange, colors.cheggOrange);
export var Link = styled(CUILink).withConfig({
  componentId: "sc-1mpvovc-6"
})(["cursor:pointer;color:", ";", ";&:visited{color:", ";}"], colors.link, footerFontSize, colors.link);
export var ErrorLink = styled(Link).withConfig({
  componentId: "sc-1mpvovc-7"
})(["font-size:", ";line-height:", ";"], font.size.px14, font.lineHeight.md);
export var P = styled.p.withConfig({
  componentId: "sc-1mpvovc-8"
})(["font-size:", ";line-height:", ";"], font.size.px12, font.lineHeight.md);